import { render, staticRenderFns } from "./Man2Create.vue?vue&type=template&id=04b886a2&"
import script from "./js/man2Create.js?vue&type=script&lang=js&"
export * from "./js/man2Create.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports